import { useState, useEffect } from 'react'

const useEnterKey = () => {
  const [keyPressed, setKeyPressed] = useState(false)

  useEffect(() => {
    const handleEnterDown = e => {
      if (e.keyCode === 13) {
        setKeyPressed(true)
      }
    }
    const handleEnterUp = e => {
      if (e.keyCode === 13) {
        setKeyPressed(false)
      }
    }

    window.addEventListener('keydown', handleEnterDown)
    window.addEventListener('keyup', handleEnterUp)
    return () => {
      window.removeEventListener('keydown', handleEnterDown)
      window.removeEventListener('keyup', handleEnterUp)
    }
  }, [])

  return keyPressed
}

export default useEnterKey
